<script lang="ts" generics="TValues, TError extends unknown">
    import type { Form } from '@jmvdevelop/svelte-form';
    import Spinner, { type SpinnerSize } from '$components/Spinner/Spinner.svelte';
    import { cx } from '$lib/utils/cx.js';
    import * as t from '$trans';
    import { getContainer } from '$components/Context/ContainerContext';

    const { lang } = getContainer();

    export let ariaLabel: string | undefined = undefined;
    let className = 'btn btn-primary';
    export { className as class };

    export let layout: 'default' | 'stable' = 'default';
    export let spinnerSize: SpinnerSize = 'sm' as const;
    export let spinnerClass: string = layout === 'default' ? 'mr-4' : 'absolute';

    export let form: Form<TValues, TError>;

    export let submittingText = t.ui.loading_etc({}, $lang);
    export let icon: string | null = null;
    export let text = t.ui.submit({}, $lang);
    export let disabled: boolean = false;
    export let forceIsSubmitting: boolean | null = null;

    $: formIsSubmitting = form.stores().isSubmitting();

    $: isSubmitting = forceIsSubmitting == null ? $formIsSubmitting : forceIsSubmitting;
</script>

<button
    type="submit"
    class={cx(className, 'flex items-center justify-center relative')}
    on:click
    {disabled}
    aria-label={ariaLabel}
>
    {#if layout === 'default'}
        {#if isSubmitting}
            <slot name="loading">
                <Spinner size={spinnerSize} class={spinnerClass} />
                {submittingText}
            </slot>
        {:else}
            {#if icon != null}
                <i class={icon} aria-hidden={true} />
            {/if}
            <slot>{text}</slot>
        {/if}
    {:else if layout === 'stable'}
        {#if isSubmitting}
            <Spinner size={spinnerSize} class={spinnerClass} />
            <span class="sr-only"><slot>{submittingText}</slot></span>
            {#if icon != null}
                <i class={cx('opacity-0', icon)} aria-hidden={true} />
            {/if}
            <span class="opacity-0"><slot>{text}</slot></span>
        {:else}
            {#if icon != null}
                <i class={icon} aria-hidden={true} />
            {/if}
            <span><slot>{text}</slot></span>
        {/if}
    {/if}
</button>
